import { attachment } from '../attachment/attachment.model';
import { Contact } from './contact.model';

export class BatchNotification {
  title: string;  
  subtitle: string;
  body: string;
  senderName: string;
  members: number[];
  scheduleTime: Date;
  attachments: attachment[];
}

export class DirectBatchNotification{
  title: string;  
  subtitle: string;
  body: string;
  senderName: string;
  contacts: Contact[];
  scheduleTime: Date;
  attachments: attachment[];
}
 